import { useEffect, useRef } from "react";
import { useExam } from "../context/ExamContext";

export default function useScrollToActiveQuestion(questionNumberOrInterval) {
    const ref = useRef(null);
    const { activeQuestion } = useExam();

    useEffect(() => {
        if (
            (Array.isArray(questionNumberOrInterval)
                ? questionNumberOrInterval.includes(activeQuestion)
                : activeQuestion === questionNumberOrInterval) &&
            ref.current
        ) {
            ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }

    }, [activeQuestion, questionNumberOrInterval]);

    return ref;
}
